import { RequestResponse } from '../../../../../core/application/http-response/http-response';
import {
  HttpClient,
  HttpMethod
} from '../../../../../core/application/protocols/http-client';
import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { error, success } from '../../../../../core/domain/either/either';
import { AccessCodeForm } from '../../domain/models/access-code-model';
import { AccessCodeResponse } from '../../domain/models/access-code-response';

export class AccessCode implements ServiceCommand<AccessCode.Response> {
  constructor(
    private readonly httpClient: HttpClient<AccessCode.Response>,
    private readonly url: string
  ) {}

  async execute(
    params: AccessCode.Params
  ): Promise<ServiceCommand.Response<AccessCode.Response>> {
    const httpResponse = await this.httpClient.request({
      method: HttpMethod.POST,
      url: this.url,
      body: params,
      queryParams: []
    });

    const responseOrError = RequestResponse.handle(httpResponse);

    if (responseOrError.isError()) {
      return error(responseOrError.value);
    }
    const response = responseOrError.value.response;

    return success(response);
  }
}

export namespace AccessCode {
  export type Params = AccessCodeForm;

  export type Response = AccessCodeResponse;
}
